import { useEffect, useState } from "react";
import React from "react";
import ENDPOINT from "../../data/ENDPOINT";

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(ENDPOINT +"leaderboard.php") // Update the path to your PHP API file
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setUsers(data.data);
        } else {
          setError(data.message || "No users found");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch users");
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center text-light">Loading...</p>;
  if (error) return <p className="text-danger text-center">Error: {error}</p>;

  const topThree = users.slice(0, 3);
  const remainingUsers = users.slice(3);

  return (
    <div className="bg-dark">
      <div className="bg-dark">
        <h1 className="leaderboard-title">Leaderboard</h1>

        <div className="container d-flex justify-content-evenly flex-wrap mt-4">
          {topThree.map((user, index) => (
            <div key={user.user_id} className="col-md-3 col-12 mb-3 mt-3">
              <div className="card custom-card">
                <div className="card-body text-center">
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <img
                      src={user.profile_pic || "default-profile.png"} 
                      alt="profile-pic"
                      className="profile-pic"
                    />
                    <h5 className="card-title">
                      {user.first_name} {user.last_name}
                    </h5>
                  </div>
                  <span className="badge rank-badge">Rank {index + 1}</span>
                  <div className="stats">
                    <div>
                      <h6>{user.points}</h6>
                      <p>Points</p>
                    </div>
                    <div>
                      <h6>{user.earnings}</h6>
                      <p>Earnings</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="table-responsive container border-1">
          <table className="table table-dark table-striped custom-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Points</th>
                <th>Rank</th>
              </tr>
            </thead>
            <tbody>
              {remainingUsers.map((user, index) => (
                <tr key={user.user_id}>
                  <td className="d-flex align-items-center">
                    <img
                      src={user.profile_pic || "default-profile.png"}
                      alt="profile-pic"
                      className="profile-pic me-2"
                    />
                    {user.first_name} {user.last_name}
                  </td>
                  <td>{user.points}</td>
                  <td>{index + 4}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <style jsx>{`
          .leaderboard-title {
            color: white;
            background-color: #343a40;
            padding: 20px;
            text-align: center;
            border-radius: 8px;
          }

          .custom-card {
            background: rgb(62, 64, 66);
            color: white;
            border-radius: 10px;
            transition: transform 0.3s ease-in-out;
          }

          .custom-card:hover {
            transform: scale(1.05);
            background: rgba(5, 5, 5, 0.05);
            box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
            backdrop-filter: blur(1.5px);
            border-radius: 10px;
            border: 1px solid rgba(255, 255, 255, 0.18);
          }

          .profile-pic {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }

          .rank-badge {
            background-color: #007bff;
            padding: 5px 10px;
            border-radius: 5px;
          }

          .stats {
            display: flex;
            justify-content: space-around;
            margin-top: 15px;
          }

          .table-responsive {
            overflow-x: auto;
          }

          @media (max-width: 768px) {
            .leaderboard-title {
              font-size: 1.2rem;
              padding: 15px;
            }

            .profile-pic {
              width: 30px;
              height: 30px;
            }

            .stats h6 {
              font-size: 0.9rem;
            }

            .custom-card {
              width: 100%;
            }
            tbody tr:hover {
              transform: scale(1.01);
              background: rgba(5, 5, 5, 0.05);
              box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
              backdrop-filter: blur(1.5px);
              border-radius: 10px;
              border: 1px solid rgba(255, 255, 255, 0.18);
            }
          }
        `}</style>
      </div>
    </div>
  );
}
